import { Typography } from "../atoms/Typography";
import WebIcon from "@mui/icons-material/Web";
import InsightsIcon from "@mui/icons-material/Insights";
import { Box, Grid } from "@mui/material";
import { ExpertiseCard } from "components/molecules/ExpertiseCard";
import { HtmlCode } from "components/molecules/HtmlCode";

export const Expertise = ({ isSmallScreen }: { isSmallScreen : boolean}) => {
  const textListLeft = [
    "Over 5 years of professional experience building full-stack web applications using React.js, Next.js, Vue.js, and TypeScript across diverse industries.",
    "Proficient in scalable backend development with Node.js, NestJS, FastAPI, and PostgreSQL (via SQLAlchemy and Prisma), with production deployments on AWS, Vercel, and Supabase.",
    "Experienced in integrating LLM APIs (Claude, Gemini) into full-stack applications, enabling conversational UI, AI-driven recommendations, and intelligent automation.",
    "Mobile development experience with Flutter, including a live App Store release (LogArabia) and cross-platform integration with web backends.",
  ];

  const textListRight = [
    "Proficient in Python, R, and SQL; skilled in training and deploying models using PyTorch, LightGBM, and Scikit-Learn on AWS production environments.",
    "Over 6 years of hands-on experience in Machine Learning and Data Science — achieved Kaggle Competitions Master (top 2% globally, ranked 3,892 of 202,646).",
    "Experienced in LLM evaluation as an AI Reviewer — structured assessment of model correctness, reasoning quality, and practical usefulness for enterprise-grade AI systems.",
    "AWS Certified Cloud Practitioner (CLF) and Grade-pre1 certified by the Japan Statistical Society, with a research background in molecular evolutionary epigenomics at the University of Tokyo.",
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          top: isSmallScreen ? "210%" : "230%",
          marginLeft: isSmallScreen ? "30%" : "50%",
          marginRight: isSmallScreen ? "30%" : "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: isSmallScreen ? "60%" : "100%",
          width: isSmallScreen ? "auto" : "60%",
        }}
      >
        <HtmlCode />
      </div>
      <Typography
        variant="h1"
        sx={{
          fontSize: {
            xs: "70px", // extra-small devices
            sm: "70px", // small devices
            md: "70px", // medium devices
            lg: "150px", // large devices
            xl: "150px", // extra-large devices
          },
        }}
      >
        Expertise
      </Typography>
      <Grid
        container
        sx={{
          paddingLeft: "3vw",
          paddingRight: "3vw",
          margin: "10vh auto",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%",
            lg: "80%",
            xl: "80%",
          },
          position: "relative",
        }}
      >
        <Grid
          item
          xs={12}
          md={5.5}
          height={isSmallScreen ? "60vh" : "70vh"}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            borderColor: "gray",
            borderStyle: "solid",
            borderWidth: "3px",
            marginBottom: isSmallScreen ? "20px" : "0px", 
          }}
        >
          <ExpertiseCard
            title={"Data Science"}
            textList={textListRight}
            icon={
              <InsightsIcon
                sx={{
                  marginRight: "2rem",
                }}
              />
            }
          ></ExpertiseCard>
        </Grid>

        <Grid item xs={isSmallScreen ? 0 : 1}></Grid>

        <Grid
          item
          xs={12}
          md={5.5}
          height={isSmallScreen ? "60vh" : "70vh"}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            borderColor: "gray",
            borderStyle: "solid",
            borderWidth: "3px",
          }}
        >
          <ExpertiseCard
            title={"Software Engineering"}
            textList={textListLeft}
            icon={
              <WebIcon
                sx={{
                  marginRight: "2rem",
                }}
              />
            }
          ></ExpertiseCard>
        </Grid>
      </Grid>
    </Box>
  );
};
